
































import { Component, Mixins } from "vue-property-decorator";
import CompaniesMixin from "@/mixins/http/CompaniesMixin";
import { Company } from "@/models";
import Page from "@/views/Page.vue";
import CompanyShowTabs from "../Tabs.vue";
import UsersList from "@/components/Company/UsersList.vue";

const requestTag = "CompanyShowTag";

@Component({ components: { Page, CompanyShowTabs, UsersList } })
export default class CompanyUsers extends Mixins(CompaniesMixin) {
  private company: Company = null;

  async created() {
    this.company = await this.loadCompany(this.getRouteId());
  }

  async loadCompany(id: string) {
    return await this.getCompany(id, requestTag);
  }

  private getRouteId(): string {
    return this.$route.params.id;
  }
  get companyLogo() {
    return {
      backgroundImage: `url(${
        this.company?.logo || require("@/assets/icons/placeholder.svg")
      })`,
    };
  }
}
